import React from "react";
import { generator } from "../utils/passwordTools";
import { Button, Stack } from "@mui/material";
import PasswordField from "./PasswordField";
import { FormattedMessage } from "react-intl";

export type PasswordGeneratorFieldProps = {
    value: string;
    onChange: (value: string) => void;
};

const PasswordGeneratorField: React.FC<PasswordGeneratorFieldProps> = ({ value, onChange }) => {
    return (
        <Stack direction="row" spacing={1}>
            <PasswordField value={value} onChange={(e) => onChange(e.target.value)} />
            <Button variant="contained" color="primary" onClick={() => onChange(generator())}>
                <FormattedMessage id="generate" />
            </Button>
        </Stack>
    );
};

export default PasswordGeneratorField;
